import React, { Component } from 'react'
import Card from '../Card'
import injectSheet from 'react-jss'
import { palette, formStyle } from '../../../Theme/Theme'
// import { Link, withRouter } from 'react-router-dom'
import Color from 'color'
// import ReactGA from 'react-ga'
import Responsive from 'react-responsive'
import TagManager from 'react-gtm-module'

const Desktop = props => <Responsive {...props} minWidth={736} />
const Mobile = props => <Responsive {...props} maxWidth={735} />

class ChoosePlanForm extends Component {
  constructor () {
    super()
    this.state = {
      frequency: 'Monthly',
      premiumYearly: '59.99/yr',
      premiumMonthly: '5.99/mo',
      basicMonthly: '2.99/mo',
      basicYearly: '29.99/yr'
    }
    this.chooseBasic = this.chooseBasic.bind(this)
    this.choosePremium = this.choosePremium.bind(this)
    this.changePlans = this.changePlans.bind(this)
  }
  render() {
    const { classes } = this.props
    const { Header, PlanMenuBody, PlanMenuBodyMobile, Plan, PlanMobile, PlanHeader, PlanHeaderMobile, PlanBody, PlanFooter, NextButton, NextButtonMobile, pricing, plansChoiceContainer } = classes
    let MonthlyPlan
    let YearlyPlan

    switch (this.state.frequency) {
      case 'Annual':
          MonthlyPlan = classes.notSelected
          YearlyPlan = classes.selected
        break
      default:
      MonthlyPlan = classes.selected
      YearlyPlan = classes.notSelected
        break
    }
    return <Card>
      <Desktop>
      <div className={Header}>
        <h1>Choose a Plan</h1>
      </div>
      <div className={plansChoiceContainer}>
        <span className={MonthlyPlan} onClick={()=>{this.changePlans('Monthly')}}>Monthly</span> | <span className={YearlyPlan}onClick={()=>{this.changePlans('Annual')}}>Annual</span>
      </div>
      <div className={PlanMenuBody}>
        <div className={Plan}>
          <div className={PlanHeader}>
            <h1>Basic</h1>
          </div>
          <div className={classes.pricingContainer}>
            <span className={pricing}><i className="fas fa-dollar-sign"/>{(this.state.frequency === 'Annual') ? this.state.basicYearly : this.state.basicMonthly}</span>
          </div>
          <div className={PlanBody}>
            <span><i className="fas fa-check-circle"/>Full Access to Spectiv Library</span>
            <span><i className="fas fa-check-circle"/>Unlimited Streaming</span>
            <span><i className="fas fa-check-circle"/>Full HD Video Quality</span>
          </div>
          <div className={PlanFooter}>
            <button className={NextButton} onClick={this.chooseBasic}>Choose Plan</button>
          </div>
        </div>
        <div className={Plan}>
          <div className={PlanHeader}>
            <h1>Premium</h1>           
          </div>
          <div className={classes.pricingContainer}>
            <span className={pricing}><i className="fas fa-dollar-sign"/>{(this.state.frequency === 'Annual') ? this.state.premiumYearly : this.state.premiumMonthly}</span>
          </div>
          <div className={PlanBody}>
          <span><i className="fas fa-check-circle"/>Full Access to Spectiv Library</span>
            <span><i className="fas fa-check-circle"/>Unlimited Streaming</span>
            <span><i className="fas fa-check-circle"/>4K Ultra HD Video Quality</span>
            <span><i className="fas fa-check-circle"/>HDR (High Dynamic Range)</span>            
          </div>
          <div className={PlanFooter}>
            <button className={NextButton} onClick={this.choosePremium}>Choose Plan</button>
          </div>
        </div>
      </div>
      </Desktop>
      <Mobile>
      <div className={Header}>
        <h1 style={{fontSize: '1.8rem'}}>Choose a Plan</h1>
      </div>
      <div style={{padding: '.5rem'}} className={plansChoiceContainer}>
        <span style={{padding: '0', paddingRight: '.4rem', paddingLeft: '.4rem'}} className={MonthlyPlan} onClick={()=>{this.changePlans('Monthly')}}>Monthly</span> | <span style={{padding: '0', paddingRight: '.4rem', paddingLeft: '.4rem'}} className={YearlyPlan}onClick={()=>{this.changePlans('Annual')}}>Annual</span>
      </div>
      <div className={PlanMenuBodyMobile}>
        <div className={PlanMobile}>
          <div className={PlanHeaderMobile}>
            <h1 style={{fontSize: '1.5rem'}}>Basic</h1>
          </div>
          <div className={classes.pricingContainerMobile}>
            <span style={{fontSize: '1rem'}} className={pricing}><i className="fas fa-dollar-sign"/>{(this.state.frequency === 'Annual') ? this.state.basicYearly : this.state.basicMonthly}</span>
          </div>
          <div className={PlanBody}>
            <span style={{fontSize: '1rem'}}><i className="fas fa-check-circle"/>Full Access to Spectiv Library</span>
            <span style={{fontSize: '1rem'}}><i className="fas fa-check-circle"/>Unlimited Streaming</span>
            <span style={{fontSize: '1rem'}}><i className="fas fa-check-circle"/>Full HD Video Quality</span>
          </div>
          <div className={PlanFooter}>
            <button className={NextButtonMobile} onClick={this.chooseBasic}>Choose Plan</button>
          </div>
        </div>
        <div className={PlanMobile}>
          <div className={PlanHeaderMobile}>
            <h1 style={{fontSize: '1.5rem'}}>Premium</h1>           
          </div>
          <div className={classes.pricingContainerMobile}>
            <span className={pricing}><i className="fas fa-dollar-sign"/>{(this.state.frequency === 'Annual') ? this.state.premiumYearly : this.state.premiumMonthly}</span>
          </div>
          <div className={PlanBody}>
          <span style={{fontSize: '1rem'}}><i className="fas fa-check-circle"/>Full Access to Spectiv Library</span>
            <span style={{fontSize: '1rem'}}><i className="fas fa-check-circle"/>Unlimited Streaming</span>
            <span style={{fontSize: '1rem'}}><i className="fas fa-check-circle"/>4K Ultra HD Video Quality</span>
            <span style={{fontSize: '1rem'}}><i className="fas fa-check-circle"/>HDR (High Dynamic Range)</span>            
          </div>
          <div className={PlanFooter}>
            <button className={NextButtonMobile} onClick={this.choosePremium}>Choose Plan</button>
          </div>
        </div>
      </div>
      </Mobile>
    </Card>
  }

  componentDidMount () {
    // ReactGA.pageview('/welcome/signup/choosePlan');
    TagManager.dataLayer({
      dataLayer: {
          event: 'PageView',
          page: '/welcome/signup/choosePlan',
      }
    })
  } 

  changePlans = (selectedPlan) => {
    this.setState({frequency: selectedPlan})
  }

  chooseBasic = e => {
    const { onSubmit, history } = this.props
    onSubmit(this.state.frequency === 'Annual' ? 'hdannual1' : 'hdmonth1')
    history.push('/welcome/signup/paymentMethod')
  }

  choosePremium = e => {
    const { onSubmit, history } = this.props
    onSubmit(this.state.frequency === 'Annual' ? '4kannual1' : '4kmonth1')
    history.push('/welcome/signup/paymentMethod')
  }
}

const styles = {
    ...formStyle,
    PlanFooter: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      flexDirection: 'column'
    },
    PlanMenuBody: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-around',
      alignItems: 'flex-start',
      flexWrap: 'wrap',
      padding: '1rem',
      color: palette.white
    },
    PlanMenuBodyMobile: {
      extend: 'PlanMenuBody',
      padding: '0'
    },
    Plan: {
      minWidth: '20rem',
      width: '20rem',
      background: 'transparent',
      borderRadius: '5px',
      // border: `1px solid ${palette.blue}`,
      // boxShadow: `2px 2px 5px 2px ${palette.blue}`,
      margin: '1rem'
    },
    PlanMobile: {
      extend: 'Plan',
      width: '85vw',
      margin: '.5rem',
      
    },
    PlanHeader: {
      textAlign: 'center',
      padding: '0.5rem .5rem',
      paddingBottom: '0'
    },
    PlanHeaderMobile: {
      extend: 'PlanHeader',
      fontSize: '1rem'
    },
    PlanBody: {
      display: 'flex',
      padding: '1rem',
      paddingBottom: '0',
      paddingTop: '0',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'flex-start',
      textAlign: 'center',
      '& span': {
        padding: '.5rem'
      },
      '& i': {
        color: palette.blue,
        marginRight: '.5rem'
      }
    },
    PlanBodyMobile: {
      extend: 'PlanBody',
    },
    pricingContainer: {
      padding: '1rem',
      width: '100%',
      textAlign: 'center'
    },
    pricingContainerMobile: {
      padding: '.5rem',
      width: '100%',
      textAlign: 'center'
    },
    plansChoiceContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      width: '100%'
    },
    pricing: {
      fontWeight: '700',
      fontSize: '1.3rem',
      transition: 'all .4s'
    },
    notSelected: {
      padding: '1rem',
      color: `${Color(palette.darkFont).darken(0.2)}`,
      transition: 'all .3s',
      '&:hover': {
        cursor: 'pointer',
        color: `${Color(palette.darkFont)}`,
      }
    },
    selected: {
      padding: '1rem',
      color: palette.orange,
      transition: 'all .3s',
      '&:hover': {
        cursor: 'pointer',
        color: `${Color(palette.orange).lighten(0.2)}`
      }
    },
    NextButtonMobile: {
      display: 'inline-block',
      margin: '.5rem .5rem 1rem .5rem',
      width: '90%',
      height: '2rem',
      lineHeight: '2rem',
      background: palette.blue,
      color: palette.lightFont,
      fontSize: '1rem',
      fontWeight: '600',
      border: 'none',
      borderRadius: '3px',
      transition: 'all .5s',
      boxShadow: `1px 1px 2px 1px ${Color(palette.black).darken(0.5)}`,
      textDecoration: 'none',
      '&:hover': {
        background: palette.purple,
        cursor: 'pointer'
      },
      '&:focus': {
        outline: 'none'
      },
      '&:active': {
        background: 'red'
      }
    }
}

export default injectSheet(styles)(ChoosePlanForm)


// WEBPACK FOOTER //
// ./src/js/Components/LandingPage/SignupComponents/ChoosePlanForm.jsx